import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Messages } from 'primereact/messages';
import { email } from '../../modulos/validation/email.js';
import { cpf } from '../../modulos/validation/cpf.js';
import { simples } from '../../modulos/validation/simples.js';
import InputMask from 'react-input-mask';
import { Password } from 'primereact/password';
import logo from '../../assets/GrupoZelo_horizontal.jpg';
import { retornoHashValor } from '../../modulos/cripotografia/hash.js';

export default class RecuperarSenha extends Component {
    constructor() {
        super();
        this.state = {
            email: '',
            erroForm: '',
            senha: '',
            cpf: ''
        };
    }

  static displayname = 'Login';

  url = retornoHashValor(process.env.REACT_APP_1);

  mess = '';

  handleSubmit = e => {
      e.preventDefault();

      if (email(this.state.email).value === false) {
          this.showError(email(this.state.email).mess);

          return false;
      }

      if (simples(this.state.senha).value === false) {
          this.showError(simples(this.state.senha).mess);

          return false;
      }

      if (cpf(this.state.cpf).value === false) {
          this.showError(cpf(this.state.cpf).mess);

          return false;
      }

      const dataToSend = {
          Email: this.state.email,
          Senha: this.state.senha,
          Cpf: this.state.cpf
      };

      fetch(`${this.url  }/recupera-senha`, {
          method: 'PUT',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataToSend)
      })
          .then(response => response.json())
          .then(responseJson => {
              if (responseJson.valido == true) {
                  this.showSuccess('Senha alterada com sucesso, redirecionando...');
                  setTimeout(() => {
                      this.props.history.push('/login');
                      window.location.reload();
                  }, 2000);
              } /*else {
          this.showError("Ops, os dados não conferem");
        };*/
          })
          .catch(err => {
              this.showError('Ops, os dados não conferem');
          });
  }

  handleEmail = e => {
      this.setState({
          email: e.target.value
      });
  }

  handleSenha = e => {
      this.setState({
          senha: e.target.value
      });
  }

  handleCpf = e => {
      this.setState({
          cpf: e.target.value
      });
  }

  showError = mess => {
      this.messages.show({ sticky: false,
          severity: 'error',
          detail: mess });
  }

  showSuccess = mess => {
      this.messages.show({ sticky: false,
          severity: 'success',
          detail: mess });
  }

  clear = () => {
      this.messages.clear();
  }

  onBlurEmail = e => {
      if (email(e.target.value).value === false) {
          this.showError(email(e.target.value).mess);
      }
  }

  render() {
      return (
          <div className="login-content">
              <center>
                  <div className="login p-col-12 p-md-5 p-lg-4">
                      <form onSubmit={this.handleSubmit}>
                          <img className="logo-responsivo" src={logo}/>
                          <p>Entre com seus dados<br /> Redefina sua senha</p>
                          <span className="loading">
                          </span>
                          <div className="p-float-label p-col-10">
                              <InputText id="email" value={this.state.value} onBlur={this.onBlurEmail} onChange={this.handleEmail} name="email_login" placeholder="Seu email" />
                          </div>
                          <div className="p-float-label p-col-10">
                              <Password id="senha" value={this.state.value} onBlur={this.onBlurSenha} onChange={this.handleSenha} name="senha" placeholder="Sua Senha" />
                          </div>

                          <div className="p-float-label p-col-10">
                              <InputMask mask="999.999.999-99" id="cpf"
                                  value={this.state.value} onBlur={this.onBlurCpf}
                                  onChange={this.handleCpf} name="cpf"
                                  placeholder="  Seu CPF"
                                  style={{ height: '35px' }}/>
                          </div>

                          <div className=" p-col-10">
                              <Messages ref={el => this.messages = el}></Messages>
                          </div>

                          <div className="redefinir">
                              <Button label="Enviar" type="submit" />
                          </div>

                          <div className="link">
                              <a href='#/login'>Ir para Login</a><br />
                          </div>
                      </form>
                  </div>
              </center>
          </div>
      );
  }
}
